const IS_AUTHENTICATED = (state, payload) => {
  state.isAuthenticated = payload.isAuthenticated
}

const SET_ROLES = (state, roles) => {
  console.log(roles)
  state.roles = roles
}

export default {
  IS_AUTHENTICATED,
  SET_ROLES
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js